module.exports = __webpack_public_path__ + "img/about2.9192f18b.png";